/**
 * Separating the Workbook Draft Rest Api version to separate
 * file as it's imported by integration tests.
 * Having this value independent from any imports avoid problems
 * with generated code
 */
export const WorkbookDraftDraftRestApiVersion = '3.9';